import { Navigation } from '@src/routing/Navigation';
import { useSearchParams } from 'react-router-dom';

export const useCurrentPermit = () => {
  const [searchParams, _] = useSearchParams();
  const permitId =
    searchParams.get(Navigation.permit.searchParamKey) ?? undefined;

  return {
    permitId,
  };
};
